import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'categoryCouponAdmin',
    serviceName: 'unitadmin',
    query: gql`
      query categoryCouponAdmin($ids: [String]) {
        categoryCouponAdmin(ids: $ids) {
          data {
            id
            title
            media {
              id
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
